module.exports = "<div class=\"margin-md\">\r\n  <div class=\"kd-item padding-md\">\r\n    <h3 class=\"typo-body-2 flex\">{{::$ctrl.empresa}}</h3>\r\n  </div>\r\n  <contabilidad-polizas-facturacion-lista-cliente\r\n      ng-repeat=\"(cliente, facturas) in $ctrl.data track by cliente\"\r\n      cliente=\"cliente\"\r\n      facturas=\"facturas\"></contabilidad-polizas-facturacion-lista-cliente>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/contabilidad/polizas/components/facturacion/lista/empresa/template.html
// module id = 1806
// module chunks = 0